import React from "react";
import nutritionImage from "../assets/images/table-4.jpg";
import MnLink from "./atoms/MnLink";
import HeadingText from "./atoms/HeadingText";
import ContentText from "./atoms/ContentText";
import { useTranslation } from "react-i18next";

const IntroSection = () => {
  const { t } = useTranslation();
  const contentText = [
    t("homepage.introsection.content.paragraph1"),
    t("homepage.introsection.content.paragraph2"),
    t("homepage.introsection.content.paragraph3"),
  ].join("\n\n");
  return (
    <section className="bg-white py-12">
      <div className="max-w-6xl mx-auto px-4 flex flex-col md:flex-row items-center gap-8">
        <div className="w-full md:w-[40%] flex justify-center mb-8 md:mb-0">
          <img
            src={nutritionImage}
            alt="Nutrition"
            className="object-cover w-full max-h-80"
          />
        </div>

        <div className="w-full md:w-[60%] flex flex-col">
          <HeadingText variant="h2">
            {t("homepage.introsection.heading")}
          </HeadingText>
          <HeadingText variant="h3">
            {t("homepage.introsection.subheading")}
          </HeadingText>

          <ContentText>{contentText}</ContentText>
          <div className="text-left mt-4">
            <MnLink
              to={`/about`}
              name={t("homepage.heroBanner.linkText")}
              classes="text-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
